import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";
import { CREDIT_CHECKER_SECTIONS } from "./constants";

/**
 * Sticky left icon-rail for the Credit Checker tab.
 *
 * Collapsed it shows only icons; on hover the whole rail expands to reveal the
 * section labels (pure CSS width transition, see credit-checker.css). Clicking
 * an item asks the parent to scroll to that section. The parent owns scroll-spy
 * and feeds the active section id back down via `activeSection`.
 */
const CreditCheckerNav = ({ activeSection, onNavigate, hiddenSections }) => (
    <nav className={"credit-checker-nav"} aria-label={"Credit Checker sections"}>
        <ul className={"credit-checker-nav__list"}>
            {CREDIT_CHECKER_SECTIONS.filter(
                section =>
                    !hiddenSections || !hiddenSections.includes(section.id)
            ).map(section => {
                const isActive = section.id === activeSection;
                return (
                    <li key={section.id}>
                        <button
                            type={"button"}
                            className={
                                "credit-checker-nav__item" +
                                (isActive
                                    ? " credit-checker-nav__item--active"
                                    : "")
                            }
                            onClick={() => onNavigate(section.id)}
                            title={section.label}
                            aria-current={isActive ? "true" : undefined}
                        >
                            <span className={"credit-checker-nav__icon"}>
                                <Icon type={section.icon} />
                            </span>
                            <span className={"credit-checker-nav__label"}>
                                {section.label}
                            </span>
                        </button>
                    </li>
                );
            })}
        </ul>
    </nav>
);

CreditCheckerNav.propTypes = {
    activeSection: PropTypes.string,
    onNavigate: PropTypes.func.isRequired,
    hiddenSections: PropTypes.arrayOf(PropTypes.string)
};

export default CreditCheckerNav;
